import FormActions from "../actions/FormActions";
import UserActions from "../actions/UserActions";

const initialState = {
  form: {},
  isValid: false,
  fileName: "",
  accessURL: "",

  resetForm: {
    started: false,
    done: false,
  },
  savedInBrowser: false,
  loadFromBrowser: {
    started: false,
    done: false,
  },
  uploadFile: {
    started: false,
    done: false,
    fetching: false,
    formValues: {},
  },
  publishXML: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  savePodcast: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
  getMyPodcast: {
    isLoading: false,
    isError: false,
    errorMessage: null,
  },
};

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case FormActions.SYNC_FORM:
      return {
        ...state,
        form: action.payload.form,
        isValid: action.payload.isValid,
      };

    case FormActions.RESET_FORM_START:
      return {
        ...state,
        resetForm: {
          ...initialState.resetForm,
          started: true,
        },
      };
    case FormActions.RESET_FORM_COMPLETE:
      return {
        ...state,
        resetForm: {
          ...initialState.resetForm,
          done: true,
        },
        fileName: "",
      };

    case FormActions.SAVE_IN_BROWSER:
      localStorage.setItem(
        "ituneXml",
        JSON.stringify({ ...state.form, fileName: state.fileName || undefined })
      );
      return {
        ...state,
        savedInBrowser: true,
      };
    case FormActions.FETCHED_FROM_BROWSER:
      return {
        ...state,
        savedInBrowser: true,
      };

    case FormActions.LOAD_FROM_BROWSER_START:
      return {
        ...state,
        loadFromBrowser: {
          ...initialState.loadFromBrowser,
          started: true,
        },
      };

    case FormActions.LOAD_FROM_BROWSER_COMPLETE:
      return {
        ...state,
        loadFromBrowser: {
          ...initialState.loadFromBrowser,
          done: true,
        },
      };

    case FormActions.UPLOAD_FILE_START:
      return {
        ...state,
        uploadFile: {
          ...initialState.uploadFile,
          started: true,
          formValues: action.payload.formValues,
        },
      };
    case FormActions.UPLOAD_FILE_INITIATED:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          fetching: true,
        },
      };
    case FormActions.UPLOAD_FILE_COMPLETE:
      return {
        ...state,
        uploadFile: {
          ...initialState.uploadFile,
          done: true,
        },
      };
    case FormActions.SET_FILE_NAME:
      return {
        ...state,
        fileName: action.payload.name,
      };

    /*===========
    PUBLISH XML
    =============*/
    case FormActions.PUBLISH_XML:
      return {
        ...state,
        publishXML: {
          ...initialState.publishXML,
          isLoading: true,
        },
      };
    case FormActions.PUBLISH_XML_SUCCESS:
      return {
        ...state,
        publishXML: initialState.publishXML,
        accessURL: action.payload.accessURL,
      };
    case FormActions.PUBLISH_XML_FAILURE:
      return {
        ...state,
        publishXML: {
          ...initialState.publishXML,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    SAVE PODCAST
    =============*/
    case FormActions.SAVE_PODCAST:
      return {
        ...state,
        savePodcast: {
          ...initialState.savePodcast,
          isLoading: true,
        },
      };
    case FormActions.SAVE_PODCAST_SUCCESS:
      return {
        ...state,
        savePodcast: initialState.savePodcast,
      };
    case FormActions.SAVE_PODCAST_FAILURE:
      return {
        ...state,
        savePodcast: {
          ...initialState.savePodcast,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    /*===========
    GET MY PODCAST
    =============*/
    case FormActions.GET_MY_PODCAST:
      return {
        ...state,
        getMyPodcast: {
          ...initialState.getMyPodcast,
          isLoading: true,
        },
      };
    case FormActions.GET_MY_PODCAST_SUCCESS:
      return {
        ...state,
        getMyPodcast: initialState.getMyPodcast,
      };
    case FormActions.GET_MY_PODCAST_FAILURE:
      return {
        ...state,
        getMyPodcast: {
          ...initialState.getMyPodcast,
          isError: true,
          errorMessage: action.payload.errorMessage,
        },
      };

    case UserActions.LOGIN_SUCCESS:
      return {
        ...state,
        form: {},
        isValid: false,
        fileName: "",
      };
    default:
      return state;
  }
};

export default formReducer;
